import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { PA_BASE, IMAGES, img, GROUP_NAME } from "../private-aviation/config";
import { EASE } from "../private-aviation/components/motion";
import { Seo } from "../private-aviation/components/Seo";

export default function CorporateShell() {
  return (
    <div className="relative min-h-screen overflow-hidden bg-[#0A0A0A] text-white" data-testid="corporate-shell">
      <Seo
        title="JS Group Holdings"
        description="JS Group Holdings — considered aviation businesses, including JS Private Aviation, the private jet charter brokerage."
      />
      <div className="absolute inset-0">
        <img src={img(IMAGES.heroTarmac, 2000)} alt="" className="h-full w-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-black/60" />
        <div className="js-grain absolute inset-0 opacity-[0.05]" />
      </div>

      <header className="relative z-10 mx-auto flex max-w-[1400px] items-center justify-between px-5 py-6 sm:px-8">
        <div className="flex items-baseline gap-2" data-testid="js-group-wordmark">
          <span className="font-display text-2xl tracking-tight">JS</span>
          <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/60">Group</span>
        </div>
      </header>

      <main className="relative z-10 mx-auto flex max-w-[1400px] flex-col justify-center px-5 pb-24 pt-24 sm:px-8 sm:pt-32">
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.1, ease: EASE }}
          className="font-mono text-[11px] uppercase tracking-[0.28em] text-white/50"
        >
          {GROUP_NAME}
        </motion.p>

        <h1 className="mt-6 font-display text-[clamp(2.4rem,7vw,5.5rem)] leading-[0.98] tracking-tight">
          {["Considered", "aviation businesses."].map((line, i) => (
            <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
              <motion.span
                className="block"
                initial={{ y: "112%" }}
                animate={{ y: 0 }}
                transition={{ duration: 1.1, delay: 0.25 + i * 0.14, ease: EASE }}
              >
                {line}
              </motion.span>
            </span>
          ))}
        </h1>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.7, ease: EASE }}
          className="mt-16 max-w-2xl"
        >
          <Link
            to={PA_BASE}
            data-testid="enter-private-aviation"
            className="group block border border-white/15 bg-white/[0.04] p-8 backdrop-blur-sm transition-colors duration-500 hover:bg-white/[0.09] sm:p-10"
          >
            <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-white/45">
              Now boarding
            </p>
            <div className="mt-4 flex items-center justify-between gap-6">
              <div>
                <h2 className="font-display text-3xl tracking-tight sm:text-4xl">JS Private Aviation</h2>
                <p className="mt-3 max-w-md text-sm leading-relaxed text-white/60">
                  Private Aviation, Simplified. Global access to private aircraft, arranged around your
                  schedule through independent operators.
                </p>
              </div>
              <ArrowUpRight
                size={28}
                className="shrink-0 text-white/40 transition-all duration-300 group-hover:translate-x-1 group-hover:-translate-y-1 group-hover:text-white"
              />
            </div>
          </Link>
        </motion.div>
      </main>

      <footer className="relative z-10 mx-auto max-w-[1400px] px-5 pb-10 sm:px-8">
        <p className="text-[11px] text-white/30">
          © {new Date().getFullYear()} {GROUP_NAME}. The full corporate website is on its way.
        </p>
      </footer>
    </div>
  );
}
